import React from "react";
import { Helmet } from "react-helmet-async";
import { useI18n } from "@/i18n/I18nProvider";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://guardmind.app";

export default function SEOHead() {
  const { locale } = useI18n();
  const isPT = locale === "pt-BR";

  const title = isPT
    ? "GuardMind — Conquiste sua dopamina."
    : "GuardMind — Earn your dopamine.";

  const description = isPT
    ? "App de disciplina que bloqueia distrações até você completar metas reais. Pontos, streak e ligas. Conquiste sua dopamina."
    : "Discipline app that blocks distractions until you complete real goals. Points, streak and leagues. Earn your dopamine.";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "GuardMind",
    applicationCategory: "LifestyleApplication",
    operatingSystem: "iOS, Android",
    description,
    url: SITE_URL,
    offers: [
      {
        "@type": "Offer",
        price: "0",
        priceCurrency: "BRL",
        name: isPT ? "Free" : "Free plan",
      },
      {
        "@type": "Offer",
        price: "12.90",
        priceCurrency: "BRL",
        name: "PRO Mensal",
      },
      {
        "@type": "Offer",
        price: "89.90",
        priceCurrency: "BRL",
        name: "PRO Anual",
      },
      {
        "@type": "Offer",
        price: "3.99",
        priceCurrency: "USD",
        name: "PRO Monthly",
      },
      {
        "@type": "Offer",
        price: "24.99",
        priceCurrency: "USD",
        name: "PRO Yearly",
      },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      ratingCount: "1240",
    },
  };

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content={isPT ? "pt_BR" : "en_US"} />
      <meta property="og:locale:alternate" content={isPT ? "en_US" : "pt_BR"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <link rel="alternate" hrefLang="pt-BR" href={`${SITE_URL}/`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}/?lang=en`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />
      <link rel="canonical" href={SITE_URL} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
